<div class="pending-terms-of-service-signature" *transloco="let t; prefix: 'pending-terms-of-service'">
    <div mat-dialog-title class="flex flex-row justify-between items-center">
        <h2>{{ data.title }}</h2>
        @if (!data.required) {
            <button mat-icon-button (click)="close()">
                <mat-icon>close</mat-icon>
            </button>
        }
    </div>

    @if (termPage()) {
        <div mat-dialog-content class="mat-typography" [innerHtml]="content | async"></div>
        <div mat-dialog-actions align="end">
            @if (!data.required) {
                <button mat-button (click)="close()">{{ t("skip") }}</button>
            }
            <button mat-flat-button color="primary" [disabled]="signing()" (click)="sign()">{{ t("sign") }}</button>
        </div>
    } @else {
        <div mat-dialog-content class="mat-typography" [innerHtml]="description | async"></div>
        <div mat-dialog-actions align="end">
            @if (!data.required) {
                <button mat-button (click)="close()">{{ t("close") }}</button>
            }
            <button mat-flat-button color="accent" (click)="next()">{{ t("next") }}</button>
        </div>
    }
</div>
